import { render, staticRenderFns } from "./InsuranceCardFooter.vue?vue&type=template&id=3efe730c&scoped=true"
import script from "./InsuranceCardFooter.vue?vue&type=script&lang=js"
export * from "./InsuranceCardFooter.vue?vue&type=script&lang=js"
import style0 from "./InsuranceCardFooter.vue?vue&type=style&index=0&id=3efe730c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efe730c",
  null
  
)

export default component.exports